import { Link } from 'react-router-dom';

const PLAYSTORE_URL =
  'https://play.google.com/store/apps/details?id=com.quizzyloot.android.online.global';

const QUICK = [
  { to: '/', label: 'Home' },
  { to: '/play', label: 'Play Quiz' },
  { to: '/minigames', label: 'Mini Games' },
  { to: '/quiz-rules', label: 'How to Play' },
];

const LEGAL = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms & Conditions' },
  { to: '/cookies', label: 'Cookie Policy' },
  { to: '/contact', label: 'Contact Us' },
];

function Column({ title, links }) {
  return (
    <div>
      <h4 className="text-xs font-black uppercase tracking-widest text-slate-400 mb-3">
        {title}
      </h4>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.to}>
            {l.external ? (
              <a
                href={l.to}
                className="text-sm text-slate-300 hover:text-white transition-colors"
              >
                {l.label}
              </a>
            ) : (
              <Link
                to={l.to}
                className="text-sm text-slate-300 hover:text-white transition-colors"
              >
                {l.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate-950 text-white">
      <div className="mx-auto max-w-site px-4 sm:px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <img src="/icon.png" alt="QuizzyLoot" className="w-8 h-8 rounded-lg" />
            <span className="text-lg font-black italic uppercase tracking-tight">
              Quizzy<span className="text-gradient-brand">Loot</span>
            </span>
          </Link>
          <p className="mt-3 text-sm text-slate-400 leading-relaxed max-w-sm">
            Play fun quizzes across general knowledge, sports, science and more.
            Answer questions and earn virtual coins — free to play, just for fun.
          </p>
          <a
            href={PLAYSTORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-3d mt-5 inline-flex items-center gap-2.5 rounded-2xl bg-white/10 hover:bg-white/15 border border-white/10 pl-3 pr-4 py-2.5"
          >
            <img src="/assets/gplay.svg" alt="" className="w-6 h-6" />
            <span className="leading-none text-left">
              <span className="block text-[8px] font-bold uppercase tracking-wide text-slate-300">
                Get it on
              </span>
              <span className="block text-sm font-black">Google Play</span>
            </span>
          </a>
        </div>

        <Column title="Explore" links={QUICK} />
        <Column title="Legal" links={LEGAL} />
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-site px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-500">
            © {year} QuizzyLoot. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">
            Credits are virtual and have no real-world cash value.
          </p>
        </div>
      </div>
    </footer>
  );
}
